(() => {
  const root = document.querySelector('[data-horror]');
  if (!root) return;
  const gate = root.querySelector('[data-horror-gate]');
  const capture = root.querySelector('[data-horror-capture]');
  const newVisitor = root.querySelector('[data-horror-new]');
  const back = root.querySelector('[data-horror-back]');
  if (gate && capture && newVisitor && back) {
    newVisitor.addEventListener('click', () => {
      gate.hidden = true;
      capture.hidden = false;
      newVisitor.setAttribute('aria-expanded', 'true');
      root.querySelector('[data-horror-register-heading]').focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: 'instant' });
    });
    back.addEventListener('click', () => {
      capture.hidden = true;
      gate.hidden = false;
      newVisitor.setAttribute('aria-expanded', 'false');
      newVisitor.focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: 'instant' });
    });
  }
  const form = root.querySelector('[data-horror-form]');
  if (!form) return;
  const status = root.querySelector('[data-horror-status]');
  const button = form.querySelector('button');
  const phoneInput = form.elements.phone;
  phoneInput.addEventListener('input', () => phoneInput.setCustomValidity(''));
  let pending = false;
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || !form.reportValidity()) return;
    const phone = phoneInput.value.trim().replace(/[\s().-]/g, '').replace(/^00/, '+');
    if (!/^\+[1-9]\d{7,14}$/.test(phone)) {
      phoneInput.setCustomValidity('Introduce un número válido con el prefijo de tu país, por ejemplo +34.');
      phoneInput.reportValidity();
      return;
    }
    const destination = new URL(root.dataset.access || '/pages/ya-estas-dentro', window.location.origin);
    if (!root.dataset.list || !root.dataset.company || destination.origin !== window.location.origin) {
      status.textContent = 'El registro estará disponible pronto. Vuelve en unos minutos.';
      return;
    }
    pending = true;
    button.disabled = true;
    status.textContent = 'Guardando tu registro…';
    const consentText = form.querySelector('[data-horror-email-notice]').textContent.trim();
    const properties = {
      horror_family_2026: true,
      whatsapp_number: phone,
      horror_consent_at: new Date().toISOString(),
      horror_consent_version: '2026-10-08-v2-button',
      horror_consent_text: consentText,
      horror_source: 'Truco o Trato · HORROR FAMILY 2026'
    };
    const params = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
      const value = params.get(key);
      if (value) properties['horror_' + key] = value.slice(0, 200);
    });
    const payload = { data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Truco o Trato · HORROR FAMILY 2026',
        profile: { data: { type: 'profile', attributes: {
          email: form.elements.email.value.trim(),
          phone_number: phone,
          properties,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      },
      relationships: { list: { data: { type: 'list', id: root.dataset.list } } }
    } };
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify(payload),
        signal: AbortSignal.timeout(20000)
      });
      if (response.status !== 202) throw new Error('Registration failed');
      const preview = params.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
      window.location.assign(destination.href);
    } catch {
      status.textContent = 'No hemos podido completar tu registro. Revisa tus datos e inténtalo otra vez.';
      pending = false;
      button.disabled = false;
    }
  });
})();
